import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { WORKSPACE_TABS, type WorkspaceTab } from '@/features/admin/shared/tabs';
import { WorkspaceDetailPage } from '@/features/admin/workspaces/workspace-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Détail d'un espace de travail (porting README #86). L'onglet actif vit dans l'URL (`?tab=`). */
export const Route = createFileRoute('/$tenant/workspaces/$workspaceId')({
  validateSearch: (search: Record<string, unknown>): { tab: WorkspaceTab } => ({
    tab: WORKSPACE_TABS.parse(search['tab']),
  }),
  component: WorkspaceRoute,
});

function WorkspaceRoute() {
  const { tenant, workspaceId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="jupyter"
      crumbs={[{ label: t('admin.workspaces.title') }, { label: workspaceId, mono: true }]}
    >
      <WorkspaceDetailPage
        tenantId={tenant}
        workspaceId={workspaceId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
